import { render, staticRenderFns } from "./UserStatus.vue?vue&type=template&id=7ff0f289&scoped=true"
import script from "./UserStatus.vue?vue&type=script&lang=js"
export * from "./UserStatus.vue?vue&type=script&lang=js"
import style0 from "./UserStatus.vue?vue&type=style&index=0&id=7ff0f289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0f289",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VExpandTransition,VLayout,VTooltip})
